import React, { useEffect } from "react";
import Lenis from "lenis";

// Wraps the app with Lenis smooth momentum scrolling.
// Respects prefers-reduced-motion.
export default function SmoothScroll({ children }) {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    // Disable via ?nolenis=1 (useful for full-page screenshot capture / automated audits)
    const params = new URLSearchParams(window.location.search);
    if (reduce || params.has("nolenis")) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.2,
    });
    // Exposed so in-page anchor jumps (e.g. the sitemap pill nav) can drive
    // the same smooth-scroll engine instead of fighting it with a native jump.
    window.__lenis = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return children;
}
